import FacebookIcon from '@8x8/oxygen-icon/icons/FacebookIcon';
import MicrosoftIcon from '@8x8/oxygen-icon/icons/WindowsIcon';
import AppleIcon from '@8x8/oxygen-icon/icons/AppleIcon';
import GoogleIcon from '@8x8/oxygen-icon/icons/GoogleIcon';

import GithubIcon from '~/components/icons/github';
import theme from '~/core/theme';
import { translate } from '~/services/translate';
import { getOperatingSystem } from '~/core/os';
import getServerConfig from '~/services/config';
import { appName } from '~/services/auth0';

let socialProvidersConfigList;

const socialProvidersServerConfig = {
  standalone: [
    'google',
    'facebook',
    'microsoft',
    'apple',
  ],
  vpaas: [
    'google',
    'facebook',
  ],
}

export const setupSocialProviders = async () => {
  try {
    const config = await getServerConfig();
    if (config) {
      const os = getOperatingSystem();
      const { standalone, vpaas } = config;
      socialProvidersServerConfig.standalone = standalone.socialProviders[os] || standalone.socialProviders.default;
      socialProvidersServerConfig.vpaas = vpaas.socialProviders[os] || vpaas.socialProviders.default;
    }
  } catch (e) { } // eslint-disable-line

  socialProvidersConfigList = [
    {
      name: 'google',
      text: translate('social_continue_with_google'),
      Icon: GoogleIcon,
      iconColor: theme.lightFont,
      connectionName: 'google-oauth2',
      backgroundColor: '#5285ED',
      backgroundColorHover: '#739CF1',
    },
    {
      name: 'facebook',
      text: translate('social_continue_with_facebook'),
      Icon: FacebookIcon,
      iconColor: theme.lightFont,
      connectionName: 'facebook',
      backgroundColor: '#415994',
      backgroundColorHover: '#6579A9',
    },
    {
      name: 'microsoft',
      text: translate('social_continue_with_microsoft'),
      Icon: MicrosoftIcon,
      iconColor: theme.lightFont,
      connectionName: 'windowslive',
      backgroundColor: '#3077CD',
      backgroundColorHover: '#5891D6',
    },
    {
      name: 'apple',
      text: translate('social_continue_with_apple'),
      Icon: AppleIcon,
      iconColor: theme.lightFont,
      connectionName: 'apple',
      backgroundColor: '#000',
      backgroundColorHover: '#262626',
    },
    {
      name: 'github',
      text: translate('social_continue_with_github'),
      Icon: GithubIcon,
      iconColor: theme.lightFont,
      connectionName: 'github',
      backgroundColor: '#25292E',
      backgroundColorHover: '#404040',
    },
  ];
}

export const getSocialProvidersConfigList = () =>
  socialProvidersServerConfig[appName()].map(spName => socialProvidersConfigList.find(sp => sp.name === spName));

/**
 * Shows the first `n` provider buttons on the main login/signup pane. The rest will go under 'More options' pane
 */
export const SHOW_FIRST_N_SOCIAL_PROVIDERS_ON_MAIN_PAGE = 2;
